import toggle from 'components/common/hoc/toggle'
import { withProps, compose } from 'recompose'
import getCorrectFilter from 'helpers/custom-price-filter'
import FilterGroupView from './components/FilterGroup'
import FilterGroupFieldView from './components/FilterGroupField'
import { FilterFacet } from './components/FilterGroup.styles'

// As specified in both Brand Details and Tire Search Results specs
const OPTIONS_PREVIEW_COUNT = 5

const withCorrectRefinements = withProps(({ refinements = []}) => ({
  refinements: getCorrectFilter(refinements)
}))

const withGroupOpenFlag = withProps(({ groupExpandedByDefault, refinements = []}) => ({
  isGroupOpen: refinements.some(({ selected } = {}) => Boolean(selected)) || groupExpandedByDefault
}))

const withGroupOptions = withProps(({ expanded, refinements = []}) => {
  const expandable = refinements.length > OPTIONS_PREVIEW_COUNT

  return {
    expandable,
    options: expandable && !expanded ?
      refinements.slice(0, OPTIONS_PREVIEW_COUNT) :
      refinements
  }
})

const withOptionsToggle = compose(
  toggle,
  withCorrectRefinements,
  withGroupOpenFlag,
  withGroupOptions
)

export const FilterGroup = withOptionsToggle(FilterGroupView)

export const FilterGroupField = withOptionsToggle(FilterGroupFieldView)

export { FilterFacet }
